import { CryptoTransactionDetails } from 'BreetComponents';
import { useWithdrawUsdRequestContext } from 'BreetHooks';

const SendCryptoTransactionDetails = () => {
	const { formDataContextProps, walletInfoOptions, walletInfoData } = useWithdrawUsdRequestContext();

	return (
		<CryptoTransactionDetails
			formDataContextProps={formDataContextProps}
			walletInfoOptions={walletInfoOptions}
			walletInfoData={walletInfoData}
			currencySymbol='$'
			type='withdraw-usd'
		/>
	);
};

export default SendCryptoTransactionDetails;
